import { useState } from 'react'

export default () => {
    const [primaryColor, setPrimaryColor] = useState('red')

    return [primaryColor, setPrimaryColor]
}
